module.exports = {
  'Loan details summary': 'Oferta de crédito',
};
